import { useEffect } from "react";
import useIsWebView from "@hooks/useIsWebview";
import useIsIOS from "@hooks/useIsIOS";
function useWebviewInputFieldFocusBehavior() {
  var adjustTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var isWebview = useIsWebView();
  var isIos = useIsIOS();
  useEffect(function () {
    // Function to handle focus and add the class
    var handleFocus = function handleFocus(event) {
      if (!isWebview || isIos) return;
      var target = event.target;
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
        var rect = target.getBoundingClientRect();
        //const scrollTop = window.scrollY + rect.top + 20;
        var scrollTop = window.scrollY + adjustTop;
        window.scrollTo({
          top: scrollTop,
          behavior: "smooth"
        });
      }
    };

    // Add event listeners to capture focus and blur events
    document.addEventListener("focusin", handleFocus);

    // Cleanup event listeners on unmount
    return function () {
      document.removeEventListener("focusin", handleFocus);
    };
  }, [isWebview]);
}
export default useWebviewInputFieldFocusBehavior;